import { render } from "./ReviewOrganizationPromptModal.vue?vue&type=template&id=5194ce31&scoped=true"
import script from "./ReviewOrganizationPromptModal.vue?vue&type=script&lang=js"
export * from "./ReviewOrganizationPromptModal.vue?vue&type=script&lang=js"

import "./ReviewOrganizationPromptModal.vue?vue&type=style&index=0&id=5194ce31&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5194ce31"]])

export default __exports__